import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import 'es6-promise/auto'

import TVERendezvousRouter from 'vue/apps/tveRendezvous/TVERendezvousRouter'
import TVERendezvousStore from 'vue/apps/tveRendezvous/TVERendezvousStore'
import Funnel from 'aa/vue/components/Funnel';
import Store from 'aa/vue/apps/rendezvous/stores/Store'
import HttpService from 'services/HttpService'
import localeBundlePlugin from 'plugins/localeBundle';
import { getBundleFromJSON } from 'services/LocalizationService';

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(localeBundlePlugin);

const serverData = JSON.parse(document.getElementById("app-config").innerHTML)
const store = Store()

store.$http = new HttpService()
store.registerModule('tve', TVERendezvousStore)
store.dispatch('loadServerData', serverData)
store.dispatch('tve/loadServerData', serverData)

const localeBundle = getBundleFromJSON();
store.commit('setLocaleDictionary', localeBundle);

const router = TVERendezvousRouter(store)

const app = new Vue({
    router,
    store,
    data: {
        debug: false,
        serverData,
    },
    components: {
        Funnel,
    }
}).$mount('#app')
